import type { Group, PrivateGroupMembership, User } from '../../state/types';

type GetPrivateGroupMembershipId = (groupId: Group['id'], userId: User['id']) => PrivateGroupMembership['id'];
export const getPrivateGroupMembershipId: GetPrivateGroupMembershipId = (groupId, userId) =>
  btoa(`${groupId}-${userId}`);

type GetPrivateGroupMembershipIds = (groupId: Group['id'], userIds: User['id'][]) => PrivateGroupMembership['id'][];
export const getPrivateGroupMembershipIds: GetPrivateGroupMembershipIds = (groupId, userIds) =>
  userIds.map((userId) => getPrivateGroupMembershipId(groupId, userId));
